import { authenticatedJsonFetch } from '@perpay-web/authentication/authenticatedJsonFetch';
import { WITHDRAWAL_REQUEST_ENDPOINT } from '@perpay-web/fintech/constants/urls';

export enum WITHDRAWAL_REQUEST_STATUS {
    SUBMITTED = 'SUBMITTED',
    CONFIRMED_BY_USER = 'CONFIRMED_BY_USER',
}

export type WithdrawalRequest = {
    status: WITHDRAWAL_REQUEST_STATUS;
    uuid: string;
    amount: number;
};

export const fetchWithdrawalRequest = (uuid: string) =>
    authenticatedJsonFetch<WithdrawalRequest>(
        `${WITHDRAWAL_REQUEST_ENDPOINT}${uuid}`,
    );
